import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import moment from 'moment';

@Injectable()
export class FiltersService {

    constructor() { }

    formatText(filterFormGroup: FormGroup, select: string, params: HttpParams, key: string): HttpParams {
        if (filterFormGroup.get(select).value) {
            params = params.set(key, filterFormGroup.get(select).value)
            return params
        }
        return params
    }

    formatSelect(filterFormGroup: FormGroup, select: string, params: HttpParams, key: string, separator: string = '|'): HttpParams {
        if (filterFormGroup.get(select).value && filterFormGroup.get(select).value.length > 0) {
            let value = '';
            for (let i = 0; i < filterFormGroup.get(select).value.length; i++) {
                value = value + String(filterFormGroup.get(select).value[i]);
                if (i + 1 !== filterFormGroup.get(select).value.length) {
                    value = value + separator
                }
            }
            params = params.set(key, value)
            return params
        }
        return params
    }

    formatRange(filterFormGroup: FormGroup, start: string, end: string, params: HttpParams, key: string, date: boolean, separator: string = '|'): HttpParams {
        if (filterFormGroup.get(start).value && filterFormGroup.get(end).value) {
            if (date) {
                params = params.set(key, moment(filterFormGroup.get(start).value).format('YYYY-MM-DD') + separator + moment(filterFormGroup.get(end).value).format('YYYY-MM-DD'));
                return params;
            } else {
                params = params.set(key, filterFormGroup.get(start).value + separator + filterFormGroup.get(end).value);
                return params;
            }
        } else if (filterFormGroup.get(start).value) {
            if (date) {
                params = params.set(key, moment(filterFormGroup.get(start).value).format('YYYY-MM-DD') + separator);
                return params;
            } else {
                params = params.set(key, filterFormGroup.get(start).value + separator);
                return params;
            }
        } else if (filterFormGroup.get(end).value) {
            if (date) {
                params = params.set(key, separator + moment(filterFormGroup.get(end).value).format('YYYY-MM-DD'));
                return params;
            } else {
                params = params.set(key, separator + filterFormGroup.get(end).value);
                return params;
            }
        } else {
            return params
        }
    }

    formatDate(filterFormGroup: FormGroup, select: string, params: HttpParams, key: string): HttpParams {
        if (filterFormGroup.get(select).value) {
            params = params.set(key, moment(filterFormGroup.get(select).value).format('YYYY-MM-DD'))
            return params
        }
        return params
    }
}
